import { closeDocumentPanel } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/documentPanelSignal';
import editingFieldSignal from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/editingFieldSignal';
import { setPendingDiscard } from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Documents/DocumentDetails/Signals/pendingDiscardSignal';

/** Closes the document sidebar, or queues a discard request when a modified draft would be lost. */
const requestCloseDocumentPanel = (): void => {
	if (editingFieldSignal.peek()?.isDirty) {
		setPendingDiscard({ type: 'close' });
		return;
	}

	closeDocumentPanel();
};

export default requestCloseDocumentPanel;
